<tx-unauthenticated-pages-wrapper>
  <form [formGroup]="loginForm" (ngSubmit)="login()">
    <h2 class="mb-6 mt-3 text-center">Log in</h2>
    <div class="form-floating">
      <input
        #firmId
        type="text"
        class="form-control mb-3 text-uppercase"
        formControlName="firmId"
        [(ngModel)]="model.firmId"
        (ngModelChange)="clearError()"
        placeholder=" " />
      <label>Firm ID</label>
    </div>
    <div class="text-danger mb-3" *ngIf="fieldInvalid('firmId')">Please provide a valid firm ID</div>
    <div class="form-floating">
      <input
        type="password"
        class="form-control mb-3"
        formControlName="password"
        [(ngModel)]="model.password"
        (ngModelChange)="clearError()"
        placeholder=" " />
      <label>Password</label>
    </div>
    <div class="text-danger mb-3" *ngIf="fieldInvalid('password')">Please enter your password</div>
    <div class="form-floating">
      <input
        type="text"
        class="form-control mb-3 text-uppercase"
        formControlName="initials"
        [(ngModel)]="model.initials"
        (ngModelChange)="clearError()"
        maxlength="5"
        placeholder=" " />
      <label>Initials</label>
    </div>
    <div class="text-danger mb-3" *ngIf="(hasInvalidCredentials || hasInvalidInitials) && !fieldInvalid('initials')">
      <label>{{ error }}</label>
    </div>

    <div class="text-danger mb-3" *ngIf="fieldInvalid('initials')">Please provide valid initials</div>
    <div class="d-grid gap-2 col-6 mx-auto mb-3 mt-4">
      <button type="submit" class="btn btn-primary" [disabled]="loading">Log in</button>
    </div>
  </form>
  <div class="text-center mb-3"></div>
  <div class="d-flex justify-content-center gap-3 align-items-center">
    <a (click)="authService.forgotFirmId()" class="text-muted">Forgot Firm ID</a>
    <span class="text-secondary text-opacity-25">|</span>
    <a (click)="authService.forgotPassword()" class="text-muted">Forgot password</a>
  </div>
</tx-unauthenticated-pages-wrapper>
